// ============================================================================
// LA GEOMETRIE DU PRISME : les sept losanges du logo Vyndra et ses lignes de
// lumiere. Sans style ni composant : partagee par l'ecran de connexion
// (app/login/prisme-ecosysteme.tsx) et par le fond commun des pages
// (components/fonds/fond-ecosysteme.tsx), qui tirent ainsi EXACTEMENT les memes
// lignes, et sans que le fond charge la feuille de style de la connexion.
// ============================================================================

/**
 * La geometrie des sept losanges, relevee sur components/vyndra-logo.tsx
 * (repere 200 x 200) : centre, demi-largeur, demi-hauteur. Dans l'ordre du
 * dessin : aile gauche de haut en bas, aile droite de haut en bas, clef.
 * Elle ne sert qu'a tirer les lignes de lumiere depuis les bonnes aretes.
 */
export const LOSANGES: ReadonlyArray<readonly [number, number, number, number]> = [
  [52, 48, 26, 20],
  [60, 76, 26, 20],
  [70, 104, 26, 20],
  [148, 48, 26, 20],
  [140, 76, 26, 20],
  [130, 104, 26, 20],
  [100, 138, 20, 20],
];

/** Longueur des lignes, en unites du repere du logo (le logo mesure 200). */
const PORTEE = 1000;

export interface Ligne {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  /** Rang du losange d'ou part la ligne. */
  rang: number;
}

/**
 * Les deux aretes EXTERIEURES de chaque losange, prolongees vers l'exterieur
 * du V : les ailes rayonnent vers leur cote, la clef vers le bas. Tirer les
 * quatre aretes donnait une resille qui traversait le formulaire ; les deux
 * aretes exterieures donnent un faisceau qui s'ouvre, comme un prisme.
 */
function tracerLignes(): Ligne[] {
  const lignes: Ligne[] = [];
  LOSANGES.forEach(([cx, cy, w, h], rang) => {
    const gauche = rang <= 2;
    const clef = rang === 6;
    // Sommets du losange.
    const haut = [cx, cy - h] as const;
    const bas = [cx, cy + h] as const;
    const cote = gauche ? ([cx - w, cy] as const) : ([cx + w, cy] as const);
    const aretes: Array<readonly [readonly [number, number], readonly [number, number]]> = clef
      ? [
          [[cx - w, cy], bas],
          [[cx + w, cy], bas],
        ]
      : [
          [haut, cote],
          [cote, bas],
        ];
    for (const [a, b] of aretes) {
      const dx = b[0] - a[0];
      const dy = b[1] - a[1];
      const n = Math.hypot(dx, dy) || 1;
      const ux = dx / n;
      const uy = dy / n;
      lignes.push({
        x1: a[0] - ux * PORTEE,
        y1: a[1] - uy * PORTEE,
        x2: b[0] + ux * PORTEE,
        y2: b[1] + uy * PORTEE,
        rang,
      });
    }
  });
  return lignes;
}

export const LIGNES = tracerLignes();
